import ReactTable from 'react-table';
import React from 'react';
import PropTypes from 'prop-types';
import Money from '../../../common/money';
import Pill from '../../../common/Pill';
import { SUBSCRIPTION_INVOICE_STATUSES, SUBSCRIPTION_INVOICE_ACTIONS } from '../constants';
import Date from '../../../common/date';
import Time from '../../../common/Time';
import RefundModal from '../../../common/RefundModal';
import { ITEM_TYPE } from '../../../register/constants';


const getStatus = (status) => {
  switch (status) {
    case SUBSCRIPTION_INVOICE_STATUSES.draft:
    case SUBSCRIPTION_INVOICE_STATUSES.open:
    case SUBSCRIPTION_INVOICE_STATUSES.uncollectible:
      return <Pill type="info">{status}</Pill>;
    case SUBSCRIPTION_INVOICE_STATUSES.void:
      return <Pill type="muted">{status}</Pill>;
    case SUBSCRIPTION_INVOICE_STATUSES.paid:
      return <Pill>{status}</Pill>;
    case SUBSCRIPTION_INVOICE_STATUSES.refunded:
      return <Pill type="danger">{status}</Pill>;
    default:
      return null;
  }
};

const getActionButtons = (status, totalAmount) => {
  switch (status) {
    case SUBSCRIPTION_INVOICE_STATUSES.paid:
      if (totalAmount > 0) {
        return [{
          action: SUBSCRIPTION_INVOICE_ACTIONS.refund,
          className: 'c-btn--red',
          label: 'Refund',
        }];
      }

      return [];
    case SUBSCRIPTION_INVOICE_STATUSES.draft:
    case SUBSCRIPTION_INVOICE_STATUSES.open:
      return [{
        action: SUBSCRIPTION_INVOICE_ACTIONS.pay,
        className: '',
        label: 'Charge',
      }, {
        action: SUBSCRIPTION_INVOICE_ACTIONS.markUncollectible,
        className: 'c-btn--white',
        label: 'Mark uncollectible',
      }];
    case SUBSCRIPTION_INVOICE_STATUSES.uncollectible:
      return [{
        action: SUBSCRIPTION_INVOICE_ACTIONS.pay,
        className: '',
        label: 'Charge',
      }];
    default:
      return [];
  }
};

const SubscriptionInvoices = ({
  subscriptionInvoices,
  processInvoice,
  currency,
  refundModalIsOn,
  refundModalOn,
  refundModalOff,
  setSelected,
  selectedInvoice,
  refund,
}) => {
  return (
    <div>
      <ReactTable
        data={subscriptionInvoices}
        showPagination={false}
        minRows={0}
        className="c-table-new c-table--small c-table--border c-no-hover u-mt"
        columns={[{
          Header: 'Amount',
          accessor: 'total',
          id: 'total',
          minWidth: 85,
          Cell: props => <Money cents={props.value} currency={currency} />,
        }, {
          Header: 'Status',
          accessor: 'status',
          id: 'status',
          minWidth: 135,
          Cell: props => getStatus(props.value),
        }, {
          Header: 'Refunded',
          accessor: 'refundedAmount',
          id: 'refundedAmount',
          minWidth: 85,
          Cell: props => (props.value ? <Money cents={props.value} currency={currency} /> : <span>-</span>),
        }, {
          Header: 'Charged at',
          accessor: 'chargedAt',
          id: 'chargedAt',
          Cell: props => (props.value ? (<span>
            <Date>{props.value}</Date>
            <br />
            <Time>{props.value}</Time>
          </span>) : <span>-</span>),
        },
        {
          Header: 'Actions',
          accessor: 'id',
          id: 'id',
          minWidth: 240,
          Cell: (props) => {
            const actions = getActionButtons(props.original.status, props.original.total);
            if (!actions.length) {
              return null;
            }

            return (<div>{actions.map(action => <button
              type="button"
              key={`${action.action}-${props.value}`}
              className={`c-btn c-btn--small u-ph- u-mr-- ${action.className}`}
              onClick={() => {
                if (action.action === SUBSCRIPTION_INVOICE_ACTIONS.refund && props.original.total > 0) {
                  setSelected({
                    id: props.value,
                    maxRefundAmount: props.original.total - props.original.refundedAmount,
                    totalCost: props.original.total,
                    itemType: ITEM_TYPE.charge,
                  });

                  return refundModalOn();
                }

                return processInvoice(props.value, action.action);
              }}
            >{action.label}</button>)}</div>);
          },
        }]}
      />
      <RefundModal
        title="Refund"
        close={refundModalOff}
        item={selectedInvoice}
        refund={refund}
        canCustomRefund
        display-if={refundModalIsOn}
      />
    </div>
  );
};

SubscriptionInvoices.propTypes = {
  subscriptionInvoices: PropTypes.array,
  processInvoice: PropTypes.func.isRequired,
  refundModalIsOn: PropTypes.bool.isRequired,
  refundModalOn: PropTypes.func.isRequired,
  refundModalOff: PropTypes.func.isRequired,
  setSelected: PropTypes.func.isRequired,
  selectedInvoice: PropTypes.object.isRequired,
  refund: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
};

SubscriptionInvoices.defaultProps = {
  subscriptionInvoices: [],
  subscriptionId: '',
};

export default SubscriptionInvoices;

